import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M15.3249 3H8.68488C8.42488 3 8.16488 3.11 7.98488 3.29L3.29488 7.98C3.11488 8.16 3.00488 8.42 3.00488 8.68V15.31C3.00488 15.58 3.11488 15.83 3.29488 16.02L7.97488 20.7C8.16488 20.89 8.42488 21 8.68488 21H15.3149C15.5849 21 15.8349 20.89 16.0249 20.71L20.7049 16.03C20.8949 15.84 20.9949 15.59 20.9949 15.32V8.68C20.9949 8.41 20.8849 8.16 20.7049 7.97L16.0249 3.29C15.8449 3.11 15.5849 3 15.3249 3ZM12.0049 17.3C11.2849 17.3 10.7049 16.72 10.7049 16C10.7049 15.28 11.2849 14.7 12.0049 14.7C12.7249 14.7 13.3049 15.28 13.3049 16C13.3049 16.72 12.7249 17.3 12.0049 17.3ZM11.0049 12C11.0049 12.55 11.4549 13 12.0049 13C12.5549 13 13.0049 12.55 13.0049 12V8C13.0049 7.45 12.5549 7 12.0049 7C11.4549 7 11.0049 7.45 11.0049 8V12Z";

export default function Report(props: IconProps) {
  return (
    <SVGIcon fillRule="evenodd" clipRule="evenodd" path={path} {...props} />
  );
}
